import type { PodcastTaxonomyFilters } from '../services/api';

/** Program Analysis includes all podcast categories (politics + other). */
export const PROGRAM_ANALYSIS_ROUTE_CATEGORY = 'all' as const;

/** Program Analysis only covers digital channels (excludes TV/radio). */
export const PROGRAM_ANALYSIS_ROUTE_CHANNEL_TYPE = 'digital' as const;

export const PROGRAM_ANALYSIS_ROUTE_TAXONOMY: PodcastTaxonomyFilters = {
  category: PROGRAM_ANALYSIS_ROUTE_CATEGORY,
  channelType: PROGRAM_ANALYSIS_ROUTE_CHANNEL_TYPE,
};

export function matchesProgramAnalysisRouteTaxonomy(podcast: {
  category?: string | null;
  type?: string | null;
}): boolean {
  return podcast.type === PROGRAM_ANALYSIS_ROUTE_CHANNEL_TYPE;
}

type SearchParamsLike = Pick<URLSearchParams, 'get'>;

/**
 * Taxonomy for /programs asset routes. Legacy share URLs used `category=other`;
 * Program Analysis now includes all digital channels (politics + other).
 */
export function resolveProgramAnalysisTaxonomyFromSearchParams(
  searchParams: SearchParamsLike,
): PodcastTaxonomyFilters {
  const categoryParam = searchParams.get('category');
  const typeParam =
    searchParams.get('type') ?? searchParams.get('channelType');

  const category =
    !categoryParam || categoryParam === 'other' || categoryParam === 'all'
      ? PROGRAM_ANALYSIS_ROUTE_CATEGORY
      : categoryParam;

  const channelType =
    !typeParam || typeParam === 'all'
      ? PROGRAM_ANALYSIS_ROUTE_CHANNEL_TYPE
      : typeParam;

  return { category, channelType };
}
